module.exports = __webpack_public_path__ + "img/regular_in_maintenance.9fb74200.svg";